'use client';

import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const statsData = [
  {
    number: '2013',
    text: 'Year founded',
  },
  {
    number: '150',
    text: 'Colleagues worldwide',
  },
  {
    number: '25',
    text: 'Team member countries',
  },
];

function AnimatedNumbers() {
  const ref = useRef(null);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    const split1 = new SplitText('.split-0', { type: 'chars' });
    const split2 = new SplitText('.split-1', { type: 'chars' });
    const split3 = new SplitText('.split-2', { type: 'chars' });

    const duration = 0.35;
    const y = -100;
    const stagger = 0.05;
    const ease = 'power4.out';
    const start = 'top 75%';
    const end = 'bottom 75%';
    const toggleActions = 'play none none reverse';

    [split1.chars, split2.chars, split3.chars].forEach(chars => {
      gsap.from(chars, {
        duration: duration,
        yPercent: y,
        stagger: stagger,
        ease: ease,
        scrollTrigger: {
          trigger: ref.current,
          start: start,
          end: end,
          toggleActions: toggleActions,
        },
      });
    });

    gsap.from('.plus-anim', {
      duration: 0.75,
      y: 60,
      stagger: 0.1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: ref.current,
        start: start,
        end: end,
        toggleActions: toggleActions,
      },
    });
  });

  return (
    <div ref={ref} className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {statsData.map((stat, index) => (
        <div
          key={index}
          className="flex h-[8rem] flex-col items-center justify-center gap-2 rounded-3xl bg-[#13171B] p-6 md:h-[9.5rem]"
        >
          <div className="flex overflow-hidden">
            <h4 className={`split-${index} text-h2`}>{stat.number}</h4>
            {index !== 0 && <span className="plus-anim text-h2">+</span>}
          </div>
          <p className="text-eyebrow-strong text-light-blue">{stat.text}</p>
        </div>
      ))}
    </div>
  );
}

export default AnimatedNumbers;
